<template>
  <div class="userManage">
    <div class="search">
      <span class="title">工作人员</span>
      <div class="flex">
        <div class="condition">
          <span style="width: 55px">辖区：</span>
          <el-select v-model="searchForm.areaId" filterable placeholder="请选择" @change="getList">
            <el-option label="全部" :value="-1"></el-option>
            <el-option v-for="(item, index) in xiaQu" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="condition">
          <span style="width: 55px">部门：</span>
          <el-select v-model="searchForm.departmentId" filterable placeholder="请选择" @change="getList">
            <el-option label="全部" :value="0"></el-option>
            <el-option v-for="(item, index) in departmentList" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="condition">
          <span style="width: 55px">状态：</span>
          <el-select v-model="searchForm.state" placeholder="请选择" @change="getList" style="width: 100px">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="正常" :value="1"></el-option>
            <el-option label="冻结" :value="0"></el-option>
          </el-select>
        </div>
        <div class="condition">
          <el-input placeholder="请输入关键字" v-model="searchForm.key">
            <el-select v-model="searchForm.keywordType" slot="prepend" placeholder="请选择" style="width: 120px">
              <el-option label="用户名" value="1"></el-option>
              <el-option label="电话号码" value="2"></el-option>
              <!-- <el-option label="部门" value="3"></el-option> -->
              <el-option label="职位" value="4"></el-option>
            </el-select>
          </el-input>
        </div>
        <el-button type="success" @click="getList">搜 索</el-button>
        <el-button type="success" @click="openDialog">新增</el-button>
        <el-button type="success" @click="switchRightDrawer">部门管理</el-button>
        <el-button type="success" @click="openExcelExport">EXCEL批量导入</el-button>
        <el-button type="success" @click="downLoad">下载导入模板</el-button>
      </div>
    </div>
    <div class="table">
      <el-table :data="tableData" v-loading="loading" element-loading-text="数据加载中..." height="700px" align="center" :header-cell-style="{ background: '#f4f7fe' }">
        <el-table-column prop="userName" label="用户名"></el-table-column>
        <el-table-column prop="phone" label="电话号码"></el-table-column>
        <el-table-column prop="department" label="部门"></el-table-column>
        <el-table-column prop="userRole" label="用户角色"></el-table-column>
        <el-table-column prop="title" label="职位"></el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.state === 0">冻结</el-tag>
            <el-tag type="success" v-else>正常</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="time" label="最后登录时间"></el-table-column>
        <el-table-column label="操作" align="right" width="280">
          <template slot-scope="scope">
            <el-button @click="edit(scope.row)" type="success" size="small">编辑</el-button>
            <el-button @click="lookDetail(scope.row)" type="success" size="small">详情</el-button>
            <el-button @click="deleteRowData(scope.row)" type="success" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50]"
        layout="sizes, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 详情对话框 -->
    <el-drawer :title="detailForm.userName" :visible.sync="detailModal" size="20%" append-to-body>
      <el-form :model="detailForm" ref="detailForm" style="padding: 10px">
        <el-form-item label="用户名" laber-width="120px">
          <span>{{ detailForm.userName }}</span>
        </el-form-item>
        <el-form-item label="电话号码" laber-width="120px">
          <span>{{ detailForm.phone }}</span>
        </el-form-item>
        <el-form-item label="部门" laber-width="120px">
          <span>{{ detailForm.department }}</span>
        </el-form-item>
        <el-form-item label="用户角色" laber-width="120px">
          <span>{{ detailForm.userRole }}</span>
        </el-form-item>
        <el-form-item label="职位" laber-width="120px">
          <span>{{ detailForm.title }}</span>
        </el-form-item>
        <el-form-item label="管理辖区" laber-width="120px">
          <span>{{ detailForm.jurisdictions }}</span>
        </el-form-item>
        <el-form-item label="状态" laber-width="120px">
          <el-tag type="danger" v-if="detailForm.state == 0">冻结</el-tag>
          <el-tag type="success" v-else>正常</el-tag>
        </el-form-item>
        <el-form-item label="最后登录时间" laber-width="120px">
          <span>{{ detailForm.time }}</span>
        </el-form-item>
      </el-form>
    </el-drawer>
    <!-- excel批量导入 -->
    <el-dialog title="excel批量导入" :visible.sync="excelDialog" width="450px" :before-close="handleClose">
      <el-form class="margin-top-sm" label-width="120px">
        <el-form-item label="部门">
          <el-cascader ref="cascaderAddr" :props="defaultProps" v-model="department" :options="departmentList" placeholder="请选择部门" :show-all-levels="false" clearable></el-cascader>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="userRole" multiple placeholder="请选择角色">
            <el-option v-for="item in RoleList" :key="item.id" :label="item.roleName" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="辖区">
          <el-select v-model="jurisdiction" multiple placeholder="请选择用户辖区">
            <el-option v-for="item in xiaQu" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文件">
          <el-upload
            class="upload-demo"
            accept=".xls,.xlsx"
            action="#"
            :limit="1"
            :on-change="
              (file) => {
                handleChange(file)
              }
            "
            :on-remove="
              (file) => {
                handleRemove(file)
              }
            "
            :file-list="excelData"
            :auto-upload="false"
          >
            <el-button size="small" type="success">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="success" @click="exportConfirm">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="导入失败人员" :visible.sync="failVisible" width="450px" :before-close="closeFailVisible">
      <div style="display: flex; flex-direction: column; justify-content: center; widows: 100%; padding: 10px; overflow: auto; max-height: 700px">
        <div v-for="(f, index) in failList" :key="index">
          <span>姓名：{{ f.userName }}--手机号：{{ f.phone }}</span>
        </div>
      </div>
    </el-dialog>
    <!-- 设置权限 -->
    <Dialog ref="worker" :isDialogVisible="dialogVisible" :dialogType="dialogType" @close-dialog="dialogVisible = $event" @dialog-confirm="handleEditConfirm" :id="id" />
    <!-- 部门管理右侧弹窗 -->
    <div class="right_drawer" ref="right_drawer">
      <i class="el-icon-close close_icon" @click="switchRightDrawer" v-if="rightDrawerShow"></i>
      <Tree v-if="rightDrawerShow"></Tree>
    </div>
  </div>
</template>

<script>
  import { GetList, GetStaffDetails, DeleteStaff, GetMyJurisdictionArea } from '@/api/staff.js'
  import Dialog from './components/workerAction.vue'
  import Tree from '@/components/divisionManagement/index.vue'
  import { GetDepartmentList } from '@/api/user.js'
  import { GetRoleSelectionBox } from '@/api/Role.js'
  import { baseUrl2 } from '@/static/utils/lyconfig'
  import request from '@/utils/axios'
  import { DownFiles } from '@/api/file'
  export default {
    name: 'workerManage',
    components: {
      Dialog,
      Tree,
    },
    data() {
      return {
        failVisible: false, //导入失败人员窗口
        failList: [], //导入失败人员信息
        searchForm: {
          keywordType: '1',
          key: '',
          departmentId: 0,
          state: -1,
          areaId: -1,
        },
        detailModal: false, //详情
        loading: false, // 数据是否处于加载状态
        tableData: [], // 表格数据
        detailForm: {}, //详情数据
        total: 0, // 数据总数
        currentPage: 1, // 当前页数
        pageSize: 10, // 当前查询数据个数
        dialogVisible: false, // 对话框是否显示
        authority: [], //当前数据所有权限
        allAuthority: [],
        authorityName: '', //当前的权限名称
        id: 0, //当前编辑id
        dialogType: 'add', //弹窗类型
        rightDrawerShow: false, //右侧
        excelData: [],
        defaultProps: {
          children: 'children',
          label: 'name',
          value: 'id',
        },
        department: [],
        userRole: [],
        departmentList: [],
        RoleList: [],
        jurisdiction: [],
        xiaQu: [],
        excelDialog: false,
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },
    },
    mounted() {
      this.getList()
      this.getUserAndDepartment()
      GetMyJurisdictionArea().then((res) => {
        if (res.data.state == 1) {
          this.xiaQu = res.data.data
        }
      })
    },
    methods: {
      // 下载导入模板
      downLoad() {
        const that = this
        that.loading = true
        let params = {
          type: 2,
          token: JSON.parse(localStorage.getItem('user-token')),
          isWorker: JSON.parse(localStorage.getItem('isWorker')) == true ? '1' : '2',
        }
        DownFiles(params).then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' }) // response就是接口返回的文件流
          let objectUrl = URL.createObjectURL(blob)
          const link = document.createElement('a') // 创建a标签
          link.href = objectUrl
          link.download = '工作人员模板.xlsx' // 自定义文件名
          link.click() // 下载文件
          URL.revokeObjectURL(objectUrl) // 释放内存
          that.loading = false
        })
      },
      // 打开批量导入框
      openExcelExport() {
        // this.getUserAndDepartment()
        this.excelDialog = true
      },
      //批量导入关闭
      handleClose() {
        this.department = []
        this.userRole = []
        this.excelData = []
        this.excelDialog = false
      },
      // 批量导确认
      async exportConfirm() {
        const that = this
        if (that.department.length == 0) {
          return that.$message.error('请选择部门')
        }
        if (that.userRole.length == 0) {
          return that.$message.error('请选择用户角色')
        }
        if (that.excelData.length == 0) {
          return that.$message.error('请上传文件')
        }
        if (that.jurisdiction.length == 0) {
          return that.$message.error('请选择辖区')
        }
        that.loading = true
        let formData = new FormData()
        let params = {
          departmentId: parseInt(that.department[that.department.length - 1]),
          userRole: JSON.stringify(that.userRole),
          jurisdiction: JSON.stringify(that.jurisdiction),
        }
        formData.append('files', that.excelData[0].raw)
        formData.append('data', JSON.stringify(params))
        success = await request({
          method: 'post',
          url: baseUrl2 + '/api/Staff/UploadStaffExcel',
          headers: { 'Content-Type': 'multipart/form-data', token: that.$store.state.user.Token },
          data: formData,
        }).then((res) => {
          if (res.status == 200) {
            if (res.data.state == 1) {
              that.$message.success(res.data.msg)
              that.loading = false
              that.handleClose()
              that.getList()
              if (res.data.data.length > 0) {
                that.failList = res.data.data
                that.failVisible = true
              }
              return true
            } else {
              return false
            }
          } else {
            that.loading = false
            return false
          }
        })
      },
      closeFailVisible() {
        this.failList = []
        this.failVisible = false
      },
      // 判断文件格式
      handleChange(file) {
        var testmsg = file.name.substring(file.name.lastIndexOf('.') + 1)
        const extension1 = testmsg === 'xls'
        const extension2 = testmsg === 'xlsx'
        if (!extension1 && !extension2) {
          return this.$message.warning('请上传xls或xlsx类型文件!')
        } else {
          this.excelData.push({ name: file.name, raw: file.raw })
        }
      },
      // 移除文件
      handleRemove() {
        this.excelData = []
      },
      // 获取用户角色和部门
      getUserAndDepartment() {
        GetRoleSelectionBox().then((res) => {
          if (res.data.state == 1) {
            this.RoleList = res.data.data
          }
        })
        GetDepartmentList().then((res) => {
          if (res.data.state == 1) {
            this.departmentList = res.data.data
          }
        })
      },
      // 分页查询
      handleSizeChange(e) {
        this.pageSize = e
        this.getList()
      },
      handleCurrentChange(e) {
        this.currentPage = e
        this.getList()
      },
      /*获取所有数据列表 */
      async getList() {
        this.loading = true
        try {
          let params = {
            pageNumber: this.currentPage,
            pageSize: this.pageSize,
            keyword: this.searchForm.key,
            keywordType: this.searchForm.keywordType,
            departmentId: this.searchForm.departmentId,
            state: this.searchForm.state,
            areaId: this.searchForm.areaId,
          }
          let { data } = await GetList(params)
          if (data.state === 1) {
            this.tableData = data.data.lis
            this.total = data.data.count
            this.loading = false
          } else {
            this.loading = false
            this.$message.error(data.message)
          }
        } catch (err) {
          // this.$message.error("获取采伐证列表列表失败,请稍后重试!");
        }
      },
      handleEditConfirm() {
        this.dialogVisible = false
        this.getList()
      },
      // 编辑
      edit(row) {
        this.dialogType = 'edit'
        this.$refs.worker.getUserAndDepartment()
        this.$refs.worker.getUserDetail(row.userCode)
        this.dialogVisible = true
      },
      /* 详情 */
      lookDetail(row) {
        GetStaffDetails(row.userCode).then((res) => {
          if (res.data.state == 1) {
            this.detailForm = res.data.data
          }
        })
        this.detailModal = true
      },
      /* 通过ID删除单行数据 */
      deleteRowData(row) {
        this.$confirm('确定删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            DeleteStaff(row.userCode).then((res) => {
              if (res.data.state == 1) {
                this.$message.success('操作成功')
                this.getList()
              } else {
                this.$message.erroe(res.data.Msg)
              }
            })
          })
          .catch(() => {})
      },
      // 打开添加弹窗
      openDialog() {
        this.dialogType = 'add'
        this.$refs.worker.getUserAndDepartment()
        this.dialogVisible = true
      },

      // 打卡部门管理抽屉
      switchRightDrawer() {
        if (this.rightDrawerShow) {
          this.$refs.right_drawer.style.width = '0px'
        } else {
          this.$refs.right_drawer.style.width = '300px'
        }

        setTimeout(() => {
          this.rightDrawerShow = !this.rightDrawerShow
        }, 100)
      },
    },
  }
</script>
<style lang="less" scoped>
  .userManage {
    height: 100%;
    width: 100%;
    position: relative;
    .search {
      padding: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .title {
        font-size: 20px;
        font-weight: bold;
      }
      .condition {
        display: flex;
        align-items: center;
        margin-right: 10px;
      }
    }
    .table {
      padding: 0px 15px;
    }
    .page {
      text-align: center;
    }
    /deep/ .el-dialog__header {
      padding: 10px;
      background-color: #5bacf0;
    }
    /deep/ .el-dialog__title {
      color: #fff;
    }
    /deep/ .el-dialog__body {
      padding: 15px;
    }
    /deep/ .el-dialog__footer {
      padding: 0px 10px 10px 10px;
    }
    .right_drawer {
      position: absolute;
      right: 0px;
      top: -15px;
      height: 100%;
      border: 1px solid #ccc;
      background-color: #fff;
      transition: all 0.3s ease;
      padding-top: 40px;
      z-index: 20;
      width: 0px;
      .close_icon {
        position: absolute;
        top: 10px;
        right: 10px;
        cursor: pointer;
        color: red;
        font-size: 22px;
      }
    }
  }
  /deep/.el-drawer {
    top: 60px !important;
  }
  .avatar {
    width: 100px;
    height: 100px;
    margin-right: 10px;
  }
</style>

